module.exports = __webpack_public_path__ + "img/xiaoshoue.369bec30.png";